import { render } from "./BookingHelpView.vue?vue&type=template&id=041ec586"
import script from "./BookingHelpView.vue?vue&type=script&lang=js"
export * from "./BookingHelpView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__